import AOS from 'aos';

export default class AnimateOnScroll {
  constructor() {
    this.selector = 'body';

    this.options = {
      offset: 0,
      duration: 600,
      easing: 'ease-in-out',
      delay: 100,
      once: true,
    };
  }

  bootstrap() {
    AOS.init(this.options);
  }
}



// WEBPACK FOOTER //
// ./scripts/components/animateOnScroll.js